import { OverlayContainer, PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";
import React from "react";
import { MeetingSourceExtended } from "../../hooks/meeting";
import { MediaGlobalControls, MediaSourcePicker } from "./MediaSourcePicker";
import styles from "./MediaConfigPopup.module.css";

export interface MediaConfigPopupProps {
  visible: boolean;
  onClose: () => void;
  sources: MeetingSourceExtended[];
}

export const MediaConfigPopup: React.FC<MediaConfigPopupProps> = ({ visible, onClose, sources }) => {
  return (
    <OverlayContainer
      visible={visible}
      style={{ position: "fixed", inset: 0, zIndex: 1000 }}
      onClose={onClose}
      overlay={
        <div className={styles.card} onClick={(e) => e.stopPropagation()}>
          <PrimaryButton className={styles.closeBtn} onClick={onClose}>
            <ReactIcons.Close style={{ height: "0.8em" }} />
          </PrimaryButton>

          <div className={styles.header}>
            <h2 className={styles.title}>Configurer mes médias</h2>
            <p className={styles.subtitle}>Choisissez votre caméra et votre micro avant de rejoindre.</p>
          </div>

          <MediaSourcePicker
            sources={sources}
            className={styles.mediaSelector}
            ignoreGestureError
          />
          <MediaGlobalControls sources={sources} className={styles.globalControls} />
        </div>
      }
    />
  );
};
